export default "__VITE_ASSET__BHJi_H8U__"